<template>
  <div>
     <section id="page-title">
            <div class="container clearfix">
                <h1 data-animate="fadeInUp">2015 WINTER</h1>
                <span data-delay="300" data-animate="fadeInUp">Dance for the Children</span>

            </div>
        </section>
        <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/1winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/1winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/2winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/2winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/3winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/3winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/4winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/4winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/5winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/5winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/6winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/6winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/7winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/7winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/8winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/8winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/9winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/9winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/10winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/10winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/11winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/11winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/12winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/12winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/13winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/13winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/14winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/14winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/15winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/15winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/16winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/16winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/17winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/17winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/18winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/18winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/19winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/19winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/20winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/20winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/21winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="_/ssets/img/winter2015/22winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/23winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/23winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/24winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/24winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <article class="portfolio-item winter2015">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html">
                                    <img src="/assets/img/winter2015/thumbs/25winter2015thumb.jpg" alt="Winter 2015 IDS" />
                                </a>
                                <div class="portfolio-overlay">
                                    <a href="/assets/img/winter2015/25winter2015.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a>
                                </div>
                            </div>
                        </article>
                        <!--winter 2015 end-->

                        <!-- Portfolio Script
============================================= -->
                        <!--<script type="text/javascript">
                            jQuery(window).load(function() {

                                var $container = $('#portfolio');

                                $container.isotope({
                                    transitionDuration: '0.65s'
                                });

                                $('#portfolio-filter a').click(function() {
                                    $('#portfolio-filter li').removeClass('activeFilter');
                                    $(this).parent('li').addClass('activeFilter');
                                    var selector = $(this).attr('data-filter');
                                    $container.isotope({
                                        filter: selector
                                    });
                                    return false;
                                });

                                $('#portfolio-shuffle').click(function() {
                                    $container.isotope('updateSortData').isotope({
                                        sortBy: 'random'
                                    });
                                });

                                $(window).resize(function() {
                                    $container.isotope('layout');
                                });

                            });
                        </script>-->
                        <!-- Portfolio Script End -->
                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
  </div>
</template>
<script>
  export default {
    name: "2015Spring", 
    components:{
    },
    mounted(){
         jQuery(window).load(function() {

            var $container = jQuery('#portfolio');

            $container.isotope({
                transitionDuration: '0.65s'
            });

            jQuery('#portfolio-filter a').click(function() {
                jQuery('#portfolio-filter li').removeClass('activeFilter');
                jQuery(this).parent('li').addClass('activeFilter');
                var selector = jQuery(this).attr('data-filter');
                $container.isotope({
                    filter: selector
                });
                return false;
            });

            jQuery('#portfolio-shuffle').click(function() {
                $container.isotope('updateSortData').isotope({
                    sortBy: 'random'
                });
            });

            jQuery(window).resize(function() {
                $container.isotope('layout');
            });

        });

    }
  }
</script>
